import { render } from "./AccordionComponent.vue?vue&type=template&id=eda5c7ee&scoped=true"
const script = {}

import "./AccordionComponent.vue?vue&type=style&index=0&id=eda5c7ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda5c7ee"]])

export default __exports__